import { createApiHooks, schemaToQueryParameters } from '@apis/next/common';
import {
  CustomsInstruction,
  CustomsInstructionAdmin,
  CustomsInstructionSearchQuery,
  PatchCustomsInstruction,
  CustomsInstructionListItemPages,
} from '@models/next/CustomsInstruction';
import { z } from 'zod';

export const customsInstructionApis = createApiHooks('/customs-instruction', [
  {
    path: '/',
    method: 'get',
    parameters: schemaToQueryParameters(CustomsInstructionSearchQuery),
    response: CustomsInstructionListItemPages,
  },
  {
    path: '/:d2d_no',
    method: 'get',
    parameters: [
      {
        name: 'd2d_no',
        type: 'Path',
        schema: z.string(),
      },
    ],
    response: CustomsInstruction,
  },
  {
    path: '/:d2d_no',
    method: 'patch',
    parameters: [
      {
        name: 'd2d_no',
        type: 'Path',
        schema: z.string(),
      },
      {
        name: 'body',
        type: 'Body',
        schema: PatchCustomsInstruction,
      },
    ],
    response: CustomsInstruction,
  },
]);

export const dashboardCustomsInstructionApis = createApiHooks('/dashboard/customs-instruction', [
  {
    path: '/:d2d_no',
    method: 'get',
    parameters: [
      {
        name: 'd2d_no',
        type: 'Path',
        schema: z.string(),
      },
    ],
    response: CustomsInstructionAdmin,
  },
  {
    path: '/:d2d_no',
    method: 'patch',
    parameters: [
      {
        name: 'd2d_no',
        type: 'Path',
        schema: z.string(),
      },
      {
        name: 'body',
        type: 'Body',
        schema: PatchCustomsInstruction,
      },
    ],
    response: CustomsInstruction,
  },
]);
